// extracted by mini-css-extract-plugin
export default {"sale":"Sale_sale__Tu9u5","error":"Sale_error__GzLOP"};